import MajorLoader from './MajorLoader'

export default MajorLoader
